export default "__VITE_ASSET__069W6Arx__"